module.exports = __webpack_public_path__ + "img/logo.nihr.65bce6b8.png";